import type { ModuleId, UserType } from '../../types';
import { getStudioBaseUrl } from '../../utils/studioUrl';
import {
  buildMarketAnalyzerUrl,
  getAiCopilotUrl,
  getMarketUrl,
  getMsiUrl,
} from './urls';

/**
 * Resolve the external app URL for a given module. Ported from mk-admin-app's
 * `module-urls.ts` so the AppSwitcher in mk-addax routes V2 users to the same
 * destinations the new admin does.
 */
export function getModuleUrl(
  moduleId: ModuleId,
  options: {
    tenantId: string;
    user: UserType | null | undefined;
  }
): string | null {
  const { tenantId, user } = options;

  switch (moduleId) {
    case 'market_analyzer': {
      const base = getMarketUrl();
      if (!base) return null;
      const isImpersonating =
        !!user?.superKudu &&
        !!tenantId &&
        String(user.permissions?.[0]?.tenant ?? '') !== tenantId;
      return buildMarketAnalyzerUrl(base, tenantId, isImpersonating);
    }
    case 'sales_copilot':
      return getMsiUrl();
    case 'ai_sales_copilot':
      return getAiCopilotUrl();
    case 'data_studio':
      return `${getStudioBaseUrl()}/tenant/${tenantId}/models`;
    default:
      return null;
  }
}
